import { createContext } from "react";
import { Feature } from "@evergis/sgis";
import { FeatureLayer } from "@evergis/sgis/es/layers/FeatureLayer";

export interface GeometrySelectionContextProps {
  drawFeature?: (feature: Feature | Feature[]) => void;
  addFeature?: (feature: Feature | Feature[], rewrite?: boolean) => void;
  replaceFeature?: (feature: Feature | Feature[]) => void;
  setFeatures?: (feature: Feature | Feature[]) => void;
  stepBack?: VoidFunction;
  stepForward?: VoidFunction;
  purgeFeatures?: VoidFunction;
  saveEditState?: VoidFunction;
  layer?: FeatureLayer;
  editLayer?: FeatureLayer;
  bufferLayer?: FeatureLayer;
}

export const GeometrySelectionContext = createContext<GeometrySelectionContextProps>({});
